import React, { Component } from "react";
import axios from "axios";
import $ from "jquery";
import Headers from "../Layouts/Headers";
import { LabSidebar } from "../Layouts/LabSidebar";
import { MDBTableEditable } from "../_mdbcomponents/components/pro/TableEditable/TableEditable";
import { MDBCard } from "../_mdbcomponents/components/Card/Card";
import { MDBCardHeader } from "../_mdbcomponents/components/Card/CardHeader/CardHeader";
import { MDBCardBody } from "../_mdbcomponents/components/Card/CardBody/CardBody";

export class BloodLiverLipid extends Component {
  constructor(props) {
    super(props);

   

    const url = "";
    this.state = {
      bloodglucoserbs: "",
      bloodglucosefbs: "",
      bloodglucosehba1: "",
      livergot: "",
      livergpt: "",
      livertotalbilr: "",
      liverdirectbilr: "",
      liveralkphos: "",
      liverggt: "",
      livertotalprotein: "",
      liveralbumin: "",
      lipidcholesterol: "",
      lipidtriglyceride: "",
      lipidhdl: "",
      lipidldl: "",
      renalcreatinine: "",
      renalurea: "",
      renalsodium: "",
      renalpotassium: "",
      renalcalcium: "",
      renalchloride: "",
      renalphosphorus: "",
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.modal = true;
  }

  componentDidMount() {
    var rowNumber = this.state["rowNumber"];
    var tableRow =
      '<tr><td><input className="form-control" name="Year" onChange={this.handleChange} value={Year}  type="text" required/> </td><td><textarea className="form-control" name="EvolutionPreviousPregnancy" onChange={this.handleChange} value={EvolutionPreviousPregnancy}></textarea></td><td><textarea className="form-control" name="InfantWeight" onChange={this.handleChange} value={InfantWeight}></textarea></td><td><textarea className="form-control" name="Sex" onChange={this.handleChange} value={Sex}></textarea></td> <td><textarea className="form-control" name="ModeDeliveryMode" onChange={this.handleChange} value={ModeDeliveryMode}></textarea></td><td><textarea className="form-control" name="InfantWeight" onChange={this.handleChange} value={InfantWeight}></textarea></td></tr>';
    $(".add-row").on("click", function () {
      $(".tableBody").append(tableRow);
    });
    this.setState({ rowNumber: parseInt(rowNumber) + 1 });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  onTableChange(event) {}

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };

    event.preventDefault();
    console.log(localStorage.getItem("objectLength"));
    var objectLength = localStorage.getItem("objectLength");

    this.setState({
      Year: this.state.tablevaluesglobal[0]["Year"],
    });

    console.log(this.state);

    for (var i = 0; i < Object.keys(this.state.tablevaluesglobal).length; i++) {
      // console.log(this.state.tablevaluesglobal[i]['Year'])

      var year = this.state.tablevaluesglobal[i]["Year"];
      var dict = {
        bloodglucoserbs: this.state.tablevaluesglobal[i]["bloodglucoserbs"],
        bloodglucosefbs: this.state.tablevaluesglobal[i]["bloodglucosefbs"],
        bloodglucosehba1: this.state.tablevaluesglobal[i]["bloodglucosehba1"],
        livergot: this.state.tablevaluesglobal[i]["livergot"],
        livergpt: this.state.tablevaluesglobal[i]["livergot"],
        livertotalbilr: this.state.tablevaluesglobal[i]["livertotalbilr"],
        liverdirectbilr: this.state.tablevaluesglobal[i]["liverdirectbilr"],
        liveralkphos: this.state.tablevaluesglobal[i]["liverdirectbilr"],
        liverggt: this.state.tablevaluesglobal[i]["liverggt"],
        livertotalprotein: this.state.tablevaluesglobal[i]["livertotalprotein"],
        liveralbumin: this.state.tablevaluesglobal[i]["liveralbumin"],
        lipidcholesterol: this.state.tablevaluesglobal[i]["lipidcholesterol"],
        lipidtriglyceride: this.state.tablevaluesglobal[i]["lipidtriglyceride"],
        lipidhdl: this.state.tablevaluesglobal[i]["lipidhdl"],
        lipidldl: this.state.tablevaluesglobal[i]["lipidldl"],
        renalcreatinine: this.state.tablevaluesglobal[i]["renalcreatinine"],
        renalurea: this.state.tablevaluesglobal[i]["renalurea"],
        renalsodium: this.state.tablevaluesglobal[i]["renalsodium"],
        renalpotassium: this.state.tablevaluesglobal[i]["renalpotassium"],
        renalcalcium: this.state.tablevaluesglobal[i]["renalcalcium"],
        renalchloride: this.state.tablevaluesglobal[i]["renalchloride"],
        renalphosphorus: this.state.tablevaluesglobal[i]["renalphosphorus"],
      };

      axios
        .post(
          this.api_url+"laboratory/tests/BloodLiverLipidRenal",
          dict,
          { headers: headers }
        )
        .then((response) => {
          console.log(response);
          // /triage/antenatal/history

          if (response.data["status"]) {
            $(".alert-success").show();
            setTimeout(function () {}, 500);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  handleTableChange(event) {
    // console.log(event);
    // this.setState({ myParentTrigger: this.state.myParentTrigger + 'a' });
  }

  formatTableOutput(data) {
    let topobj = {};
    let tableobj = {};
    for (let i = 0; i < data.length; i++) {
      let trim = data[i];
      let trimobj = {};
      this.setState({
        Year: "1212",
      });

      trimobj.bloodglucoserbs = data[i][0];
      trimobj.bloodglucosefbs = data[i][1];
      trimobj.bloodglucosehba1 = data[i][2];
      trimobj.livergot = data[i][3];
      trimobj.livergpt = data[i][4];
      trimobj.livertotalbilr = data[i][5];
      trimobj.liverdirectbilr = data[i][6];
      trimobj.liveralkphos = data[i][7];
      trimobj.liverggt = data[i][8];
      trimobj.livertotalprotein = data[i][9];
      trimobj.liveralbumin = data[i][10];
      trimobj.lipidcholesterol = data[i][11];
      trimobj.lipidtriglyceride = data[i][12];
      trimobj.lipidhdl = data[i][13];
      trimobj.lipidldl = data[i][14];
      trimobj.renalcreatinine = data[i][15];
      trimobj.renalurea = data[i][16];
      trimobj.renalsodium = data[i][17];
      trimobj.renalpotassium = data[i][18];
      trimobj.renalcalcium = data[i][19];
      trimobj.renalchloride = data[i][20];
      trimobj.renalphosphorus = data[i][21];

      tableobj[i] = trimobj;
      topobj.prepplan = tableobj;
    }
    this.state.tablevaluesglobal = topobj["prepplan"];
  }

  getTableValues(event) {
    let tablevalues = this.formatTableOutput(event);
    console.log(tablevalues);
  }

  render() {
    //Editable table variables
    const data = [
      [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ],
    ];

    const columns = [
      "bloodglucoserbs",
      "bloodglucosefbs",
      "bloodglucosehba1",
      "livergot",
      "livergpt",
      "livertotalbilr",
      "liverdirectbilr",
      "liveralkphos",
      "liverggt",
      "livertotalprotein",
      "liveralbumin",
      "lipidcholesterol",
      "lipidtriglyceride",
      "lipidhdl",
      "lipidldl",
      "renalcreatinine",
      "renalurea",
      "renalsodium",
      "renalpotassium",
      "renalcalcium",
      "renalchloride",
      "renalphosphorus",
    ];

    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    return (
      <div>
        <Headers />
        <LabSidebar />
        <main className="content-container">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="col-md-4 text-lg-center font-weight-bold p-1">
                <p className="text-capitalize" style={font16}></p>
              </div>
              <MDBCard>
                <MDBCardHeader
                  tag="h3"
                  className="text-center font-weight-bold text-capitalise py-4"
                >
                  BloodLiverLipid
                </MDBCardHeader>
                <MDBCardBody>
                  <MDBTableEditable
                    onChange={(value) => this.handleTableChange(value)}
                    getValue={(value) => this.getTableValues(value)}
                    myParentTrigger={this.state.myParentTrigger}
                    id="editablecard"
                    data={data}
                    columns={columns}
                    striped
                    bordered
                  />
                </MDBCardBody>
              </MDBCard>

              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details Saved Successfully.
              </div>
              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default BloodLiverLipid;
